import React from 'react';

import { connectHits } from 'react-instantsearch-dom';
import { ProducerSearchHit } from '/components/producer-search/components';

const sort = (a, b) => {
    if (a.title > b.title) {
        return 1;
    }

    if (a.title < b.title) {
        return -1;
    }

    return 0;
};

const ProducerSearchResultsListInternal = ({ hits }) => (
    <div className="ais-Hits producer-search-results-list">
        {hits.length === 0 && (
            <div>Geen resultaten gevonden</div>
        )}
        <ul className="ais-Hits-list">
            {hits.sort(sort).map((hit) => (
                <li className="ais-Hits-item" key={hit.id}>
                    <ProducerSearchHit hit={hit} />
                </li>
            ))}
        </ul>
    </div>
);

const ProducerSearchResultsList = connectHits(ProducerSearchResultsListInternal);

export { ProducerSearchResultsList };
